import { createSlice } from '@reduxjs/toolkit'
import { getTestSteps, saveTestStep, createTestStep, deleteTestStep } from './testStepActions'

const initialState = {
  testSteps: [],
  loading: false,
  loadingError: false,
  loaded: false,
  saving: false,
  savingError: false,
  saved: false,
  savedTestStep: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

/*function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}*/

const testStepsSlice = createSlice({
  name: 'testSteps',
  initialState,
  reducers: {
    clear: (state) => {
      state.loading = false
      state.loadingError = false
      state.loaded = false

      state.saving = false
      state.savingError = false
      state.saved = false
      state.savedTestStep = {}

      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getTestSteps.fulfilled, (state, { payload }) => {
        state.loading = false
        state.loaded = true
        state.loadingError = null
        state.testSteps = payload
      })
      .addCase(getTestSteps.pending, (state) => {
        state.loading = true
        state.loaded = false
        state.loadingError = null
      })
      .addCase(getTestSteps.rejected, (state, { payload }) => {
        state.loading = false
        state.loaded = false
        state.loadingError = payload
      })
      .addCase(saveTestStep.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveTestStep.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.testSteps[state.testSteps.findIndex((p) => p.id === payload.id)] = payload
        state.savedTestStep = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveTestStep.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createTestStep.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createTestStep.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedTestStep = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createTestStep.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteTestStep.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteTestStep.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteTestStep.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
  },
})

export const { clear } = testStepsSlice.actions
export default testStepsSlice.reducer
